
export const getAssessmentMeta = (type) => {
  switch (type?.toLowerCase()) {
    case 'phq9':
      return { 
        label: 'PHQ-9 Depression', 
        max: 27,
        ranges: [
          { max: 4, name: 'None', color: '#10B981' }, // Green
          { max: 9, name: 'Mild', color: '#F59E0B' }, // Yellow
          { max: 14, name: 'Moderate', color: '#F97316' }, // Orange
          { max: 19, name: 'Moderately Severe', color: '#EF4444' }, // Red
          { max: 27, name: 'Severe', color: '#B91C1C' } // Dark Red
        ]
      };
    case 'gad7':
      return { 
        label: 'GAD-7 Anxiety', 
        max: 21,
        ranges: [
          { max: 4, name: 'None', color: '#10B981' },
          { max: 9, name: 'Mild', color: '#F59E0B' },
          { max: 14, name: 'Moderate', color: '#F97316' },
          { max: 21, name: 'Severe', color: '#B91C1C' }
        ]
      };
    case 'pss10':
      return { 
        label: 'PSS-10 Stress', 
        max: 40,
        ranges: [
          { max: 13, name: 'Low Stress', color: '#10B981' },
          { max: 26, name: 'Moderate Stress', color: '#F59E0B' },
          { max: 40, name: 'High Stress', color: '#B91C1C' }
        ]
      };
    case 'k10':
      return {
        label: 'K10 Distress',
        max: 50,
        ranges: [
          { max: 19, name: 'Likely to be well', color: '#10B981' },
          { max: 24, name: 'Mild', color: '#F59E0B' },
          { max: 29, name: 'Moderate', color: '#F97316' },
          { max: 50, name: 'Severe', color: '#B91C1C' }
        ]
      };
    default:
      return { label: type?.toUpperCase(), max: 20, ranges: [] };
  }
};
// MindVault can store the full interpretation in severity_level. Keep the client
// summary concise using the existing score bands, without changing saved data.
export const getAssessmentSeverityLabel = (type, assessment) => {
  if (!['phq9', 'gad7'].includes(type?.toLowerCase())) {
    return assessment?.severity_level || '';
  }
  const rawScore = assessment?.total_score;
  if (rawScore == null || (typeof rawScore !== 'number' && typeof rawScore !== 'string')
      || (typeof rawScore === 'string' && rawScore.trim() === '')) return '';
  const score = Number(rawScore);
  const meta = getAssessmentMeta(type);
  if (!Number.isInteger(score) || score < 0 || score > meta.max) return '';
  return meta.ranges.find(range => score <= range.max)?.name || '';
};

export const getSeverityColor = (severity) => {
  const norm = severity?.toLowerCase();
  if (norm?.includes('severe')) return '#EF4444'; // Red
  if (norm?.includes('moderate')) return '#F97316'; // Orange
  if (norm?.includes('mild')) return '#F59E0B'; // Yellow
  return '#10B981'; // Green
};
export const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
export const getRiskStyles = (level) => {
    switch ((level || '').toUpperCase()) {
        case 'HIGH':
        return { bg: '#FEE2E2', text: '#B91C1C', border: '#FCA5A5' };
        case 'MEDIUM':
        return { bg: '#FEF3C7', text: '#B45309', border: '#FCD34D' };
        case 'LOW':
        return { bg: '#F3F4F6', text: '#4B5563', border: '#D1D5DB' };
        default:
        return { bg: '#F3F4F6', text: '#4B5563', border: '#D1D5DB' };
    }
    };
